import {Basic} from "./Basic";

export class Podcastplayer
{
    constructor(container)
    {
        this.container = container;
        this.container.classList.add('initialized');
        this.playButton = this.container.querySelector('.w__podcast--control-play');
        this.time = this.container.querySelector('.w__podcast--time');
        this.duration = this.container.querySelector('.w__podcast--duration');
        this.timelinePointer = this.container.querySelector('.w__podcast--timeline-pointer');
        this.audio = this.container.querySelector('.w__podcast--player');
        this.add_events();
        this.playing = false;
    }

    add_events()
    {
        if(this.audio.readyState)
        {
            this.set_duration();
        }
        else
        {
            this.audio.addEventListener('loadedmetadata', () =>
            {
                this.set_duration();
            });
        }

        this.audio.addEventListener('ended',() =>
        {
            this.toggle_play(true);
            this.set_time();
        });

        this.audio.addEventListener('timeupdate',() =>
        {
            this.set_time();
        });

        this.container.addEventListener('click', e => {
            const el = e.target;
            if(el.classList.contains('w__podcast--control'))
            {
                switch(el.dataset.f)
                {
                    case 'ff':
                        this.seek_position(15);
                        break;

                    case 'fr':
                        this.seek_position(-15);
                        break;

                    case 'play':
                        this.toggle_play();
                        break;
                }
            }
            else if(el.classList.contains('w__podcast--timeline'))
            {
                this.set_position((e.clientX - el.getBoundingClientRect()['left']) * 100
                                   / el.getBoundingClientRect()['width']);
            }
        });
    }

    convert_time(seconds)
    {
        return Math.floor(seconds / 60) + ':' + ('00' + Math.floor(seconds % 60)).slice(-2);
    }

    set_duration()
    {
        this.duration.textContent = this.convert_time(this.audio.duration);
    }

    set_position(percent)
    {
        this.audio.currentTime = this.audio.duration * percent / 100;
        this.set_time();
    }

    seek_position(seconds)
    {
        this.audio.currentTime += seconds;
        this.set_time();
    }

    set_time()
    {
        this.time.textContent = this.convert_time(this.audio.currentTime);
        this.set_timelinePointer();
    }

    set_timelinePointer()
    {
        let percent = this.audio.currentTime * 100 / this.audio.duration;
        this.timelinePointer.style.left = percent.toString() + '%';
    }

    static stop_allPlayers(container)
    {
        const podcasts = document.body.querySelectorAll('.w__podcast--container');
        for(let i=0; i<podcasts.length; i++)
        {
            if((!container || podcasts[i] !== container) &&
               podcasts[i].player)
            {
                podcasts[i].player.toggle_play(true);
            }
        }

        const audios = document.body.querySelectorAll('.w__link--audio.active');
        for(let i=0; i<audios.length; i++)
        {
            Podcastplayer.toggle_audio(audios[i],true);
        }

        if(Basic.sculpture)
        {
            Basic.sculpture.stop_audio();
        }

        // set button to stop
        const playButton = document.body.querySelector('#w--nav .w__button[data-action="toggle-play"]');
        if(playButton)
        {
            playButton.classList.remove('mod--off');
        }
    }

    static toggle_audio(el, forceOff)
    {
        if(el.classList.contains('active') && el.audio || forceOff === true)
        {
            el.classList.remove('active');
            if(el.audio)
            {
                el.audio.pause();
                el.audio.remove();
                el.audio = undefined;
            }
        }
        else
        {
            Podcastplayer.stop_allPlayers();
            el.audio = new Audio(el.href);
            el.insertAdjacentElement('afterend', el.audio);
            el.audio.addEventListener('ended',() => {
               Podcastplayer.toggle_audio(el,true);
            });
            const playPromise = el.audio.play();
            if(playPromise !== undefined)
            {
                el.classList.add('active');
                playPromise.catch(error =>
                {
                    console.error(error);
                });
            }
        }
    }

    toggle_play(forceOff)
    {
        if(this.playing === true || forceOff === true)
        {
            this.audio.pause();
            this.playing = false;
            this.playButton.classList.remove('playing')
            if(forceOff === true)
            {
                this.audio.currentTime = 0;
            }
            this.container.closest('.w__tile').classList.remove('w__tile--highlight');
        }
        else
        {
            Podcastplayer.stop_allPlayers(this.container);
            this.audio.play();
            this.playing = true;
            this.playButton.classList.add('playing')
            this.set_duration();
            this.container.closest('.w__tile').classList.add('w__tile--highlight');
        }
    }
}